import primary from './primary'
import paper from './paper'
import paperLg from './paper-lg'
import interactive from './interactive'

export default {
  primary,
  paper,
  'paper-lg': paperLg,
  interactive
}
